// @flow
import React from 'react';
import LazyLoad from 'react-lazyload';
import AppStoreIcon from '../../../static/images/appstore_bt.svg';
import GooglePlayIcon from '../../../static/images/googleplay_bt.svg';
import { track } from '../../helpers/Tracking/Analytics';

type Props = {
  baseClassName?: string,
  modifier?: string | Array<string> | null,
  lazyLoad?: boolean,
  startStop?: boolean
};

const AppIcons = ({
  baseClassName = 'c-appIcons',
  modifier = null,
  lazyLoad = true,
  startStop = false
}: Props) => {
  let className = baseClassName;

  if (modifier) {
    if (Array.isArray(modifier)) {
      className = `${baseClassName} ${modifier
        .map(mod => `${baseClassName}--${mod}`)
        .join(' ')}`;
    } else {
      className += ` ${baseClassName}--${modifier}`;
    }
  }

  return (
    <>
      {modifier === 'AppFeature' && (
        <p className="c-downloadApp__appIcons__text">Or Download From:</p>
      )}
      <ul className={className}>
        <li>
          <a
            onClick={() =>
              startStop
                ? track('temp:search-results:clicked-appstore', {
                    appstore_type: 'Apple'
                  })
                : track('click:download-app:ios')
            }
            target="_blank"
            rel="noopener noreferrer"
            href="https://itunes.apple.com/GB/app/id519652671?mt=8"
          >
            {lazyLoad ? (
              <LazyLoad offset={100} height={30}>
                <img src={AppStoreIcon} alt="AppStore" />
              </LazyLoad>
            ) : (
              <img src={AppStoreIcon} alt="AppStore" />
            )}
          </a>
        </li>
        <li>
          <a
            onClick={() =>
              startStop
                ? track('temp:search-results:clicked-appstore', {
                    appstore_type: 'Google'
                  })
                : track('click:download-app:android')
            }
            target="_blank"
            rel="noopener noreferrer"
            href="https://play.google.com/store/apps/details?id=com.justpark.jp"
          >
            {lazyLoad ? (
              <LazyLoad once offset={100} height={0}>
                <img src={GooglePlayIcon} alt="Google Play" />
              </LazyLoad>
            ) : (
              <img src={GooglePlayIcon} alt="Google Play" />
            )}
          </a>
        </li>
      </ul>
    </>
  );
};

export default AppIcons;
